<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clipbriefcase)">
      <path d="M14.4035 3.63037H10.9576V2.24181C10.9576 1.58065 10.4197 1.04279 9.75851 1.04279H6.24025C5.57909 1.04279 5.0412 1.58065 5.0412 2.24181V3.63037H1.59524C0.717404 3.63037 0.00320884 4.34456 0.00320884 5.2224C0.00320884 6.01978 -0.0784524 6.73588 0.525803 7.54119C0.867683 7.99682 1.3375 8.32185 1.88443 8.48107L7.19556 10.0274C7.72136 10.1805 8.27725 10.1806 8.80314 10.0274L14.1143 8.48107C14.6612 8.32181 15.131 7.99682 15.4729 7.54119C16.0799 6.73226 15.9955 6.0088 15.9955 5.2224C15.9955 4.34456 15.2814 3.63037 14.4035 3.63037ZM6.05681 2.24181C6.05681 2.14066 6.13911 2.05839 6.24025 2.05839H9.75851C9.85966 2.05839 9.94196 2.14069 9.94196 2.24181V3.63037H6.05681V2.24181Z" fill="currentColor"/>
      <path d="M14.3984 9.45612C8.6697 11.1241 8.74388 11.1578 7.99956 11.1578C7.26058 11.1578 7.4359 11.1551 1.60075 9.45615C0.985512 9.27699 0.440638 8.94679 0.00341797 8.49158V13.3651C0.00341797 14.243 0.717582 14.9571 1.59545 14.9571H14.4037C15.2815 14.9571 15.9957 14.243 15.9957 13.3651V8.49158C15.5585 8.94676 15.0136 9.27699 14.3984 9.45612Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clipbriefcase">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
name: "IconBriefcase"
}
</script>

<style scoped>

</style>